export default __webpack_public_path__ + "static/media/percentIcon.f23f4483.svg";